( () => {

  const accordionGroup = document.querySelectorAll('.accordion-group');
  const accordion = document.querySelectorAll('.accordion');
  
  accordion.forEach( element => {
    element.addEventListener('click', () => {
      const contentHeight = element.nextElementSibling.querySelector('.accordion-content-wrap').offsetHeight + 'px';
      
      if (element.classList.contains('active')) {
        element.classList.remove('active');
        element.nextElementSibling.style.maxHeight = '0px';
      } else {
        element.classList.add('active');
        element.nextElementSibling.style.maxHeight = contentHeight;
      }
    });
  });
  
  const faqSearchInput = document.getElementById('faq-search');
  let faqSearchValue = '';
  
  if (faqSearchInput) {
    faqSearchInput.addEventListener('keyup', () => {
      faqSearchValue = faqSearchInput.value.trim().toLowerCase();
      
      if (faqSearchValue === '') {
        accordionGroup.forEach( element => {
          element.style.display = "block";
        });
        return true;
      }

      accordionGroup.forEach( element => {
        const textContent = element.textContent.toLowerCase();
        
        if (textContent.includes(`${faqSearchValue}`)) {
          element.style.display = "block";
        } else {
          element.style.display = "none";
        }
      });
      return true;
    });

    
  }

  const faqSearchForm = document.getElementById('faq-search-form');
  const accordionGroupArray = [...document.querySelectorAll('.accordion-group')];
  
  if (faqSearchForm) {
    faqSearchForm.addEventListener('submit', (event) => {
      event.preventDefault();
      
      if (faqSearchValue !== '') {
        const faqMatchedElement = accordionGroupArray.find( element => element.textContent.toLowerCase().includes(`${faqSearchValue}`));

        if(typeof faqMatchedElement !== 'undefined') {
          const offset = faqMatchedElement.offsetTop;
          window.scrollTo(0, offset);
        }
      }
    });
  }
  
})();